import Vue from 'vue';
import Tip from '../components/Tip.vue';

class Toast {
  msg: string;
  el: any;
  during: number;
  timer: any;
  type: string;

  constructor(prop: any) {
    this.msg = prop.msg;
    this.el = null;
    this.during = prop.duration || 2000;
    this.timer = null;
    this.type = prop.type;
  }

  info() {
    this.el = this.create();
    try {
      document.body.appendChild(this.el.$el);
    } catch (e) {
      console.error(e);
    }
    this.timer = setTimeout(() => {
      this.hide();
    }, this.during);
  }

  create() {
    const TipCom = Vue.extend(Tip);
    return new TipCom(
      {
        el: document.createElement('div'),
        propsData: {
          type: this.type,
          msg: this.msg,
        }
      }
    );
  }

  hide() {
    document.body.removeChild(this.el.$el);
    clearTimeout(this.timer);
    this.el = null;
  }
}

export default {
  show(type: string, msg: string, duration: number = 2000) {
    const tip = new Toast({
      type, msg, duration
    });
    tip.info();
  }
};
